const ENV = process.env.NODE_ENV;
let prefix = ""

if (ENV == "development") {
    prefix = '/api'
} else {
    prefix = window.g_config.urlPrefix
}

module.exports = {
    prefix: prefix
}
